import {
  Autocomplete,
  FormControl,
  FormControlLabel,
  FormLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Stack,
  TextField,
} from '@mui/material';
import { FieldEditorSection } from 'components/FieldEditor/types/FieldEditorSection';
import React from 'react';

import { ConstraintsManager } from '../ConstraintsManager';
import { InputArea } from '../InputArea';

export function ComputedMeta({ field, setField }: FieldEditorSection) {
  const meta = field.meta || {};

  const updateMeta = (updates: any) => {
    setField({
      ...field,
      meta: {
        ...meta,
        ...updates,
      },
    });
  };

  return (
    <InputArea name="Meta" description="Meta configuration for computed fields">
      <Stack gap={3}>
        {/* Type */}
        <TextField
          fullWidth
          label="Type"
          select
          value={meta.type || 'number'}
          onChange={(e) => updateMeta({ type: e.target.value })}
        >
          <MenuItem value="string">String</MenuItem>
          <MenuItem value="number">Number</MenuItem>
          <MenuItem value="boolean">Boolean</MenuItem>
        </TextField>

        {/* Function */}
        <TextField
          fullWidth
          label="Function"
          select
          value={meta.function || 'sum'}
          onChange={(e) => updateMeta({ function: e.target.value })}
        >
          <MenuItem value="sum">Sum</MenuItem>
          <MenuItem value="average">Average</MenuItem>
          <MenuItem value="count">Count</MenuItem>
          <MenuItem value="min">Min</MenuItem>
          <MenuItem value="max">Max</MenuItem>
        </TextField>

        {/* Filter */}
        <FormControl>
          <FormLabel>Filter</FormLabel>
          <RadioGroup
            value={Array.isArray(meta.filter) ? 'constraints' : 'children'}
            onChange={(e) => {
              if (e.target.value === 'children') {
                updateMeta({ filter: 'children' });
              } else {
                updateMeta({ filter: [] });
              }
            }}
          >
            <FormControlLabel
              value="children"
              control={<Radio />}
              label="Children"
            />
            <FormControlLabel
              value="constraints"
              control={<Radio />}
              label="Constraints"
            />
          </RadioGroup>
        </FormControl>

        {/* Constraints Manager (shown when filter is constraints) */}
        {Array.isArray(meta.filter) && (
          <ConstraintsManager
            field={{
              ...field,
              constraints: meta.filter,
            }}
            setField={(updatedField) => {
              updateMeta({ filter: updatedField.constraints });
            }}
          />
        )}

        {/* Dependencies */}
        <Autocomplete
          multiple
          freeSolo
          options={[]}
          value={Array.isArray(meta.dependencies) ? meta.dependencies : []}
          onChange={(_, newValue) => {
            updateMeta({ dependencies: newValue });
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Dependencies"
              placeholder="Add dependency..."
            />
          )}
        />
      </Stack>
    </InputArea>
  );
}
